import {TimelineLite, TweenLite} from "gsap";

interface IStaggerTweenConfiguration {
    element: HTMLElement;
    props: Record<string, any>;
}

export function stagger(delay: number) {
    let counter = 0;
    let lastCallTime = 0;

    return (tweens: IStaggerTweenConfiguration[], duration: number, timeScale: number) => {
        const now = new Date().getTime();
        if (now > lastCallTime + duration * timeScale * 1000) {
            counter = 0;
        }

        const timeLine = new TimelineLite();
        timeLine.timeScale(timeScale);

        for (const {element, props} of tweens) {
            timeLine.to(element, duration, {
                ...props,
                delay: counter * delay,
            }, 0);
        }

        lastCallTime = now;
        counter++;

        return timeLine;
    }
}